module.exports = __webpack_public_path__ + "img/emoji_hover.c054929d.svg";